export class MinaMaskinlagTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        minaMaskinlag: "Mina maskinlag",
        samtligaMaskinlag: "Samtliga maskinlag",
        andringarSparats: "Ändringarna har sparats",
        lamnaModalHeader: "Osparade ändringar",
        lamnaModalBody: "Det finns osparade ändringar, vill du spara innan sidan lämnas?"
    };
}
